import React, { useEffect, useState } from "react";
import ExplorerService from '../../services/API/explorerService';
import ArticlesBGImgOne from '../../assets/images/dashboard/articles-1.svg';
import { useNavigate, useSearchParams } from "react-router-dom";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { stripHtmlTags } from "helper/extension";
import { Image } from "components/componentIndex";
import LeftChevron from '../../assets/images/left-chevron.svg';

const ArticlesDetails = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const postId = parseInt(searchParams.get('postId'));
    const [isLoading, setIsLoading] = useState(false);
    const [articleDetail, setArticleDetail] = useState([]);

    useEffect(() => {
        // Initialize AOS only once on mount
        AOS.init({
            offset: 200, // Trigger animations 200px from the top
            delay: 100, // Delay animations by 100ms
            duration: 500, // Animation duration in milliseconds
            easing: 'ease-in-out', // Default easing for animations
            once: false, // Whether animations should only happen once
            mirror: false, // Whether animations should happen on scroll up
        });

        // Fetch post details on component mount
        getPostDetails();
    }, []);

    const getPostDetails = async () => {
        try {
            setIsLoading(true); // Show loading state
            const response = await ExplorerService.getPostDetails(postId);
            if (response?.statusCode === 200) {
                setArticleDetail(response.result);
            }
        } catch (error) {
            console.error("Failed to fetch posts:", error);
        } finally {
            setIsLoading(false); // Hide loading state
        }
    };

    const isMobile = () => window.innerWidth <= 768; // Utility function to determine if mobile

    const aosArticleEffects = () =>
        `fade-${isMobile() ? "top" : "left"}`;

    const handleBackScreen = () => {
        window.history.back();
    }

    return (
        <div className="custom-container appintment-detail">
            <div className="d-flex align-center justify-content-start">
                <div onClick={handleBackScreen} className='cursor-pointer confirm-req-back'>
                    <Image imgUrl={LeftChevron} altText={'Left Chevron'} />
                </div>
                <h2 className="page-title">Articles</h2>
            </div>
            <div className=" mb-4">
                {articleDetail?.id ? (
                    <div
                        key={articleDetail?.id} // Add a unique key for React
                        className="article-card "
                        data-aos={aosArticleEffects()}
                        data-aos-anchor-placement="top-bottom"
                        data-aos-offset="200"
                    >
                        <div
                            className="cursor-pointer appintment-bg shadow"
                            style={{
                                backgroundImage: `url(${articleDetail.coverImage || ArticlesBGImgOne})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                backgroundRepeat: "no-repeat",
                            }}
                        ></div>
                        <div className="article-description mt-4">
                            <p className="title my-2">
                                {articleDetail?.title?.split(":")[0]}
                            </p>
                            <p className="sub-title mt-2 mb-4">
                                {articleDetail?.title?.split(":")[1]}
                            </p>
                            {/* <p className="description mb-0">
                                {stripHtmlTags(articleDetail?.body)}
                            </p> */}

                            <div className="artical-body"
                                style={{ fontFamily: `'SF UI Display', sans-serif`, fontSize: "16px", fontWeight: '400', textAlign: 'left', marginTop: "20px", lineHeight: "1.6", color: "#222222" }}
                                dangerouslySetInnerHTML={{ __html: articleDetail.body }}
                            ></div>
                        </div>
                    </div>
                ) : isLoading ? (
                    Array.from({ length: 1 }).map((_, index) => (
                        <div
                            key={index} // Add a unique key for React
                            className="article-card skeleton"
                            data-aos={aosArticleEffects()}
                            data-aos-anchor-placement="top-bottom"
                            data-aos-offset="200"
                        >
                            <div className="article-bg-img appintment-bg cursor-pointer skeleton-bg"></div>
                            <p className="skeleton-title"></p>
                            <p className="skeleton-text"></p>
                        </div>
                    ))
                ) : (
                    <div className="content">No articles details scheduled yet</div>
                )}
            </div>
        </div>
    );
};

export default ArticlesDetails;
